import React from 'react';
import { SectionTitle } from '../ui/SectionTitle';
import { Target, Eye, Heart } from 'lucide-react';

export function Nosotros() {
    return (
        <section className="py-16 px-4 max-w-6xl mx-auto" id="nosotros">
            <SectionTitle subtitle="Conocé nuestra misión">
                ¿Quiénes somos?
            </SectionTitle>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="bg-white rounded-2xl p-6 shadow-sp text-center">
                    <div className="w-16 h-16 bg-sp-light rounded-full flex items-center justify-center mx-auto text-sp-primary">
                        <Target size={32} />
                    </div>
                    <h3 className="text-xl font-black mt-4">Misión</h3>
                    <p className="text-sp-body text-sm mt-2">
                        Democratizar la protección de mascotas, ofreciendo una herramienta
                        simple, eterna y accesible para que ningún dueño vuelva a perder a su amigo.
                    </p>
                </div>
                <div className="bg-white rounded-2xl p-6 shadow-sp text-center">
                    <div className="w-16 h-16 bg-sp-light rounded-full flex items-center justify-center mx-auto text-sp-primary">
                        <Eye size={32} />
                    </div>
                    <h3 className="text-xl font-black mt-4">Visión</h3>
                    <p className="text-sp-body text-sm mt-2">
                        Ser el ecosistema de protección animal más confiable de Latinoamérica,
                        conectando a millones de mascotas con sus familias.
                    </p>
                </div>
                <div className="bg-white rounded-2xl p-6 shadow-sp text-center">
                    <div className="w-16 h-16 bg-sp-light rounded-full flex items-center justify-center mx-auto text-sp-primary">
                        <Heart size={32} />
                    </div>
                    <h3 className="text-xl font-black mt-4">Valores</h3>
                    <p className="text-sp-body text-sm mt-2">
                        Transparencia, innovación, amor por los animales y compromiso
                        con la tranquilidad de las familias.
                    </p>
                </div>
            </div>
        </section>
    );
}